/**
 * Video component.
 * Plays videos when they should autoplay. Some autoplay attributes work fine in browsers, but this will ensure full browser compatibility.
 *
 * Usage:
 * Call Video.init() to initialize the navbar functionalities.
 *
 * Methods:
 *
 * init(): plays
*/

const video = () => {
		
	document.querySelectorAll('.js-mute-button').forEach($button => {
		const $videos = document.querySelectorAll(`[data-video-ref="${$button.dataset.videoTarget}"]`);
		$button.addEventListener('click', e => {
			e.preventDefault();

			let isMuted = true;
			$videos.forEach($video => {
				// If video is visible, mute and unmute
				if ($video.muted && $video.offsetHeight > 0) {
					$video.muted = !$video.muted;
					isMuted = $video.muted;
				} else {
					$video.muted = true;
				}
			});
			$button.classList.toggle('is-unmuted', !isMuted);
		});
	});

	const tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	const firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	
	window.yt_players = [];
	global.onYouTubeIframeAPIReady = function() {
		const $modals = document.getElementsByClassName('video-modal-yt');
		for (let i = 0; i < $modals.length; i++) {
			window.yt_players.push(new YT.Player($modals[i].id + '-player'));
		}
	};
};

const onResize = () => {
	// Muting video if more than one with same ref button exists
	document.querySelectorAll('.js-mute-button').forEach($button => {
		document.querySelectorAll(`[data-video-ref="${$button.dataset.videoTarget}"]`).forEach($video => {
			if (!$video.muted && $video.offsetHeight < 1) {
				$video.muted = true;
				$button.classList.remove('is-unmuted');
			}
		});
	});
};

module.exports = {
	init: video,
	onResize
};
